import { ethers } from 'ethers';

export const encodeAddress = (address: string): string => {
  return Buffer.from(address).toString('base64');
};

export const decodeAddress = (encoded: string): string => {
  const decoded = Buffer.from(encoded, 'base64').toString();
  return ethers.utils.isAddress(decoded) ? decoded : ethers.constants.AddressZero;
};